import React from 'react';

const BS_Filters = () => {
    return (
        <div>
            <h1>BS_Filters Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Filters;
